<template>

  <v-container
    id="dashboard-page"
     fluid grid-list-xs text-xs-center
  >
<!--  <h1 class="page-title display-1">Dashboard</h1> -->
  <calendar ref="calendar"></calendar>
      <br>
        <v-btn
        v-if="$store.getters['api/getUserRol'] !== 'installer' && $store.getters['api/getUserRol'] !== 'manager' && $store.getters['api/getUserRol'] !== 'responsible'"
              :to="createBookingRoute"
            >
              Crear reserva
            </v-btn>
                    <v-btn

              :to="bookingsRoute"
            >
              Ver reservas
            </v-btn>
                                <v-btn

              :to="statsRoute"
            >
              Ver estadísticas
            </v-btn>
          </v-container>

</template>

<script>
  import Calendar from '@/components/calendar'

  export default {
    components: {
      Calendar
    },

    data () {
      return {
        isMounted: false,
        bookingsRoute: {
          name: 'bookings'
        },
        createBookingRoute: {
          name: 'booking-id',
          params: {
            booking_id: 'new'
          }
        },
        statsRoute: {
          name: 'stats'
        }
      }
    },

    watch: {
      'statisticsPeriod' () { }
    },

    mounted () {
      this.isMounted = true
    },

    methods:
    {
      onChangePeriod (period) {
      },
      getCardStyle () {
      }
    }
  }
</script>

<style lang="sass">
#dashboard-page
  max-width: 900px !important
  .vuetify-btn-toggle
    padding: 30px
</style>



// WEBPACK FOOTER //
// src/pages/dashboard.vue